import { ListaPerguntas } from 'api/DuvidasFrequentes';

import { Messenger } from 'store/modules/WSAssembleiasReducer';

export enum Sections {
  'list',
  'ask',
  'answer',
}

interface DuvidasState {
  idEvento: number;
  perguntas: ListaPerguntas | null;
  isLoading: boolean;
  message: Messenger | null;
  destaque: number | string | null;
}

type DuvidasActionTypes =
  | 'setPerguntas'
  | 'loading'
  | 'loaded'
  | 'setMessage'
  | 'setEvento'
  | 'setDestaque';

interface DuvidasAction {
  type: DuvidasActionTypes;
  value?: any;
}

export const duvidasInitialState: DuvidasState = {
  isLoading: false,
  perguntas: null,
  message: null,
  idEvento: 0,
  destaque: null,
};

export const duvidasReducer = (
  state: DuvidasState,
  action: DuvidasAction
): DuvidasState => {
  switch (action.type) {
    case 'loading':
      return { ...state, isLoading: true };
    case 'loaded':
      return { ...state, isLoading: false };
    case 'setPerguntas':
      return { ...state, perguntas: action.value };
    case 'setMessage':
      return { ...state, message: action.value };
    case 'setEvento':
      return { ...state, idEvento: action.value };
    case 'setDestaque':
      return { ...state, destaque: action.value };
    default:
      return state;
  }
};
